import React from 'react';
import List from 'fe-design-base/molecules/List/List';

import { toI18n } from 'util/i18n';

import { testMinChars, testMinLetters, testMinNumbers } from './helpers';

type Props = {
  password: string;
};
const PasswordVerificationList = ({ password }: Props) => (
  <List
    variant="checklist"
    data={[
      {
        primary: toI18n('authentication.password_verification.characters'),
        success: testMinChars(password),
      },
      {
        primary: toI18n('authentication.password_verification.letters'),
        success: testMinLetters(password),
      },
      {
        primary: toI18n('authentication.password_verification.numbers'),
        success: testMinNumbers(password),
      },
    ]}
  />
);

export default PasswordVerificationList;
